<template>
  <div>
    <transition name="slide-fade" mode="out-in">
      <component :is="activeStep" />
    </transition>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import SelectPlanStep from '../components/subscription/SelectPlanStep';
  import AuthStep from '../components/subscription/AuthStep';
  import DeliveryStep from '../components/subscription/DeliveryStep';
  import SummaryStep from '../components/subscription/SummaryStep';
  import GiftForm from '../components/gift/GiftForm';

  export default {
    components: {
      SelectPlanStep,
      AuthStep,
      DeliveryStep,
      SummaryStep,
      GiftForm
    },
    computed: {
      ...mapGetters({
        activeStep: 'GET_ACTIVE_STEP',
        selectedPlan: 'GET_SELECTED_PLAN',
      })
    },
    watch: {
      activeStep(newStep, oldStep) {
        this.$gtm.trackView(`prenumerata/${newStep}`, 'currentPath');

        // eslint-disable-next-line
        fbq('track', 'ViewContent', {
          content_name: this.selectedPlan.title,
          content_category: `prenumerata/${newStep}`,
          content_ids: [ this.selectedPlan.ID ],
          content_type: 'product',
        });
      }
    }
  }
</script>

<style lang="scss">
  .router-link {
    $size: 48px;
    background: transparent;
    border: 1px solid var(--color-gray);
    font-weight: 700;
    color: var(--color-gray);
    font-family: var(--font-marat);
    font-size: var(--font-24);
    font-variant: lining-nums;
    border-radius: 50%;
    text-decoration: none;
    display: flex;
    padding: .5em;
    width: $size;
    height: $size;
    justify-content: center;
    align-items: center;

    &.router-link-exact-active {
      background: var(--color-pink);
      border-color: var(--color-pink);
      color: var(--color-white);
    }
  }
  nav {
    ul {
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      justify-content: center;
      li {
        margin: 0 1em;
      }
    }
  }
</style>
